import { FiscalNoteModel } from "../../../../../../domain/models/fiscal-note";
import { makeRemoteFiscalNote } from "../../../../../../main/factories/usecases/fiscal-note/remote-fiscal-note-factory";

const cancelFiscalNote = async (noteId: number): Promise<FiscalNoteModel> =>
  makeRemoteFiscalNote().cancel(noteId);

export default cancelFiscalNote;
